import { render, staticRenderFns } from "./AddCountry.vue?vue&type=template&id=0a4ce63c&scoped=true&"
import script from "./AddCountry.vue?vue&type=script&lang=js&"
export * from "./AddCountry.vue?vue&type=script&lang=js&"
import style0 from "./AddCountry.vue?vue&type=style&index=0&id=0a4ce63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ce63c",
  null
  
)

export default component.exports